 
/* eslint-disable import/order */
import * as PrimarySdk from './__generated/primary/sdk'
import * as RelaySdk from './__generated/relay/sdk'

export { type SdkFunctionWrapper } from './lib/getBaseSdk'

import type * as RelayTypes from './__generated/relay/types'
import type * as PrimaryTypes from './__generated/primary/types'

export { PrimaryTypes, RelayTypes }

/** @deprecated In the future, these types should derived from the types in util or imported using the `PrimaryTypes` or `RelayTypes` namespace */
export * from './__generated/primary/types'

export { type ResultOf, type VariablesOf } from './utils'

export { getPurpositySdk, type PurpositySdk as Sdk } from './main'

const { getSdk: _primary_getSdk, ...primary_Documents } = PrimarySdk
const { getSdk: _relay_getSdk, ...relay_Documents } = RelaySdk
export const Documents = {
  ...primary_Documents,
  ...relay_Documents,
}
